const Vue = require('vue').default;

export default Vue.extend({
    data(){
        return {

        }
    },
    methods : {
        countOrderItemQuantity(data){
            let count = 0;
            data.order_items.map((item, index) => {
                count += item.quantity;
            });
            return count;
        },
    }
});
